"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpellCheckerSettings = exports.SpellCheckerError = void 0;
var SpellCheckerError = (function () {
    function SpellCheckerError() {
    }
    return SpellCheckerError;
}());
exports.SpellCheckerError = SpellCheckerError;
var SpellCheckerSettings = (function () {
    function SpellCheckerSettings() {
        this.isEnabled = false;
        this.customDictionaryGuid = "";
        this.canAddWord = false;
        this.suggestionCount = 4;
    }
    SpellCheckerSettings.prototype.copyFrom = function (obj) {
        this.isEnabled = obj.isEnabled;
        this.suggestionCount = obj.suggestionCount;
        this.customDictionaryGuid = obj.customDictionaryGuid;
        this.canAddWord = obj.canAddWord;
        this.maxRequestLength = obj.maxRequestLength && obj.maxRequestLength > 0 ? obj.maxRequestLength : 300;
        this.checkWordSpelling = obj.checkWordSpelling;
        this.addWordToDictionary = obj.addWordToDictionary;
    };
    SpellCheckerSettings.prototype.clone = function () {
        var result = new SpellCheckerSettings();
        result.copyFrom(this);
        return result;
    };
    return SpellCheckerSettings;
}());
exports.SpellCheckerSettings = SpellCheckerSettings;
